import React from "react";
import { Link } from "react-router-dom";

const BackArrow = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <line x1="19" y1="12" x2="5" y2="12" />
    <polyline points="12 19 5 12 12 5" />
  </svg>
);

const AboutUs: React.FC = () => {
  return (
    <main className="mx-auto px-4 py-8">
      <Link
        to="/dashboard"
        className="inline-flex items-center gap-2 text-[#003366] font-medium mb-6 hover:bg-[#003366] rounded-md px-3 py-2 hover:text-white transition-colors duration-200"
      >
        <BackArrow />
        Back to Dashboard
      </Link>

      <h1 className="text-3xl font-bold text-[#003366] text-center mb-8">
        About Us
      </h1>

      <p className="text-gray-700 text-base leading-relaxed mb-4">
        The Ministry of Social Justice and Empowerment is the Nodal Ministry for
        matters relating to the Senior Citizens. Constant increase in life
        expectancy due to improvement in the health care facilities over the
        years is one of the main reasons for rapid increase in proportion of
        population of Senior Citizens. As per Census 2011, the total population
        of Senior Citizens (people aged 60 years and above) is 10.38 crore, of
        which population of males and females are 5.11 crore and 5.27 crore
        respectively.
      </p>
      <p className="text-gray-700 text-base leading-relaxed mb-4">
        The Ministry develops and implements Acts, Policies and Programmes for
        welfare of Senior Citizens in collaboration with State Governments/
        Union Territory Administrations to ensure that Senior Citizens may lead
        a secured, dignified and productive life.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        <section className="bg-slate-100 rounded-2xl p-8">
          <h2 className="text-xl font-semibold text-[#003366] mb-4">Vision</h2>
          <p className="text-gray-700 text-base leading-relaxed">
            A society in which Senior Citizens live a healthy, happy, empowered,
            dignified and self-reliant life along with strong social and
            inter-generational bonding.
          </p>
        </section>

        <section className="bg-slate-100 rounded-2xl p-8">
          <h2 className="text-xl font-semibold text-[#003366] mb-4">Mission</h2>
          <p className="text-gray-700 text-base leading-relaxed">
            Building an inclusive society by providing access to all Indian
            senior citizens adequate food, water, shelter, clothing, health
            care, financial and social security, recreation, required
            opportunities and resources for their self-fulfillment and
            empowerment with development of a formal and informal social support
            system.
          </p>
        </section>
      </div>
    </main>
  );
};

export default AboutUs;
